export default __webpack_public_path__ + "static/media/theme-image.fe78a60d.png";